import React, { createElement, useMemo } from 'react';
import imageApi from '@umu/umu-image-handle';

interface IProps {
    children: React.ReactElement;
    option?: imageApi.IProcessOptions;
}

/**
 * 对 img 预处理，添加 width，rote 等参数
 * @author Kody
 * @returns img
 */
export const PreImg = (props: IProps) => {
    const { children, option = {} } = props;
    if (!children || children.type !== 'img') {
        return children;
    }

    return useMemo(() => {
        const childProps = { ...children.props };
        if (typeof children.props.src === 'string') {
            childProps.src = imageApi.process(children.props.src, option);
        }
        return createElement('img', childProps);
    }, [children]);
};
